<div class="centered-message">
  <img src="assets/logo/pdocs.svg" alt="overlayer logo" class="logo" />
  <span class="informative-message"
    >The various features are now accessible directly in Google Drive.</span
  >
  <a href="https://drive.google.com/drive/" target="_blank">Google drive</a>
</div>
